import { render, staticRenderFns } from "./GameHUDButton.vue?vue&type=template&id=eb805f00&scoped=true&"
var script = {}
import style0 from "./GameHUDButton.vue?vue&type=style&index=0&id=eb805f00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb805f00",
  null
  
)

export default component.exports